import theme from '@styles/theme';
export default {
  progressBarContainer: {
    '.row__column:not(.row__column--paddingless)': {
      paddingLeft: 0,
      paddingRight: 0
    }
  },
  progressBar: (actual: number, max: number) => {
    const progress = actual / max * 100;
    return {
      height: '2px',
      width: '100%',
      backgroundColor: theme.rawColors.lightGrey300,
      margin: '16px auto',
      position: 'relative',
      '&:after': {
        content: '" "',
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        width: `${progress}%`,
        maxWidth: '100%',
        backgroundColor: theme.rawColors.neutralBlack,
        transition: 'width .3s linear'
      }
    };
  }
};